import { IconBase, IconBaseProps } from 'react-icons';

import { IconManifest } from 'app/agriculture/icons/types';

export const boundingRect: IconManifest = {
    id: 'bounding-rect',
    width: 56,
    height: 56,
    d: 'M4 52L32 52C43.0457 52 52 43.0457 52 32L52 4',
};

export function BoundingRect(props: IconBaseProps) {
    const { id, d } = boundingRect;

    return (
        <IconBase id={id} {...props} viewBox="0 0 56 56" data-testid="BoundingRect" fill="none">
            <path d={d} stroke="currentColor" strokeWidth="8" strokeLinecap="round" />
        </IconBase>
    );
}
